import React, { useState } from 'react';
import pb from '../../services/pocketbase';
import Modal from '../Modal/Modal';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';

function CategoryManager({ categories, onCategoryAdded, onCategoryUpdated, onCategoryDeleted }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [categoryForm, setCategoryForm] = useState({ name: '' });

  const handleCategoryChange = (e) => {
    const { name, value } = e.target;
    setCategoryForm(prev => ({ ...prev, [name]: value }));
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setEditingCategory(null);
    setCategoryForm({ name: '' });
  };

  const handleCategorySubmit = async (e) => {
    e.preventDefault();
    if (!categoryForm.name.trim()) return;

    const data = { name: categoryForm.name };

    try {
      if (editingCategory) {
        const updated = await pb.collection('categories').update(editingCategory.id, data);
        onCategoryUpdated(updated);
        alert('Catégorie mise à jour !');
      } else {
        const created = await pb.collection('categories').create(data);
        onCategoryAdded(created);
        alert('Catégorie ajoutée !');
      }
      handleCancel();
    } catch (error) {
      console.error("Erreur lors de l'opération sur la catégorie:", error);
      alert(`Erreur: ${error.message}`);
    }
  };

  const showEditCategoryForm = (category) => {
    setEditingCategory(category);
    setCategoryForm({ name: category.name });
    setIsModalOpen(true);
  };

  const showAddCategoryForm = () => {
    setEditingCategory(null);
    setCategoryForm({ name: '' });
    setIsModalOpen(true);
  };

  const handleDeleteCategory = async (id) => {
    // Note: PocketBase cascade delete should handle products if set up in DB rules.
    // If not, manual deletion of products would be needed here.
    if (!window.confirm("Supprimer cette catégorie ? Cela peut affecter les produits associés.")) return;
    try {
      await pb.collection('categories').delete(id);
      onCategoryDeleted(id);
      alert('Catégorie supprimée.');
    } catch (error) {
      console.error("Erreur lors de la suppression de la catégorie:", error);
      alert(`Erreur: ${error.message}`);
    }
  };

  const renderCategoryForm = () => (
    <form onSubmit={handleCategorySubmit} className="dashboard-form">
      <input name="name" type="text" placeholder="Nom de la catégorie" value={categoryForm.name} onChange={handleCategoryChange} required />
      <div className="form-actions">
        <button type="submit">{editingCategory ? 'Mettre à jour' : 'Ajouter'}</button>
        <button type="button" onClick={handleCancel} className="cancel-btn">Annuler</button>
      </div>
    </form>
  );

  const renderCategoryList = () => (
    <div>
      <div className="list-header">
        <h4>{categories.length === 0 ? 'Catégories' : 'Catégories existantes'}</h4>
        <button onClick={showAddCategoryForm}>Ajouter une catégorie</button>
      </div>
      {categories.length === 0 ? (
        <div className="empty-list-message">
          <p>Aucune catégorie trouvée. Commencez par en ajouter une !</p>
        </div>
      ) : (
        <div className="items-list">
          <ul>
            {categories.map(c => (
              <li key={c.id}>
                <span>{c.name}</span>
                <div className="item-actions">
                  <button onClick={() => showEditCategoryForm(c)} className="edit-btn" title="Modifier"><FaPencilAlt /></button>
                  <button onClick={() => handleDeleteCategory(c.id)} className="delete-btn" title="Supprimer"><FaTrash /></button>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );

  return (
    <>
      {renderCategoryList()}
      <Modal
        isOpen={isModalOpen}
        onClose={handleCancel}
        title={editingCategory ? 'Modifier la catégorie' : 'Ajouter une catégorie'}
      >
        {renderCategoryForm()}
      </Modal>
    </>
  );
}

export default CategoryManager;
